import { jsx } from "react/jsx-runtime";
import { AffordabilityCalculator } from "@zillow/zhl-public-web-components";
import "react";
const BlockAffordabilityCalculatorV2 = () => /* @__PURE__ */ jsx(AffordabilityCalculator, { env: process.env.NEXT_PUBLIC_ENV === "prod" ? "prod" : "dev" });
BlockAffordabilityCalculatorV2.propTypes = {};
export {
  BlockAffordabilityCalculatorV2 as default
};
